export interface IServerResponse<T> {
    data: T;
    //messages: { type: string, msg: string }[];
    //type: number;
    totalPages?: number;
    totalRows?: number;
    status: { messages: string[], success: boolean };
}

export interface IPaginationResponse<T> {
    total: number;
    items: T[];
    page: number;
    pageSize: number;
}

export interface IComboList {
    list: any[];
    loading: boolean;
}

export class ComboList implements IComboList {
    list = [];
    loading = false;

    constructor(arr: any[] = []) {
        this.list = arr;
    }
}